export default {
  label: 'Interactions',
  placeholder: 'Indifferent',
  selected: 'selected',
  selectedPlural: 'selected',
};
